import classnames from 'classnames'
import React, { ReactNode } from 'react'

interface IFlexBoxProps {
  children: ReactNode
  isCenter?: boolean
}

export const FlexBox = (props: IFlexBoxProps) => {
  const { isCenter = false } = props
  const flexBoxClassNames = classnames('flex-box', {
    'flex-box--vcenter': isCenter,
  })

  return <div className={flexBoxClassNames}>{props.children}</div>
}
